import { Scaffold } from 'layouts';
import { PendingStocks } from 'components/Pages/Stock/PendingStocks';
import { StockLayout } from 'layouts/Stock';

export const ListPendingPage: React.FC = () => {
  return (
    <Scaffold>
      <StockLayout>
        <PendingStocks />
      </StockLayout>
    </Scaffold>
  );
};
